import PropTypes from 'prop-types'
import React from 'react'
import cx from 'classnames'

import { remove } from 'store/reducers/notifications'

import classes from './Snackbar.scss'
import MdCancel from 'react-icons/lib/md/cancel'

export default class Snackbar extends React.Component {
  static propTypes = {
    notification_type: PropTypes.string,
    timeout: PropTypes.number,
    message: PropTypes.node,
    showClose: PropTypes.bool,
    id: PropTypes.string.isRequired,

    dispatch: PropTypes.func.isRequired
  }

  static defaultProps = {
    timeout: 5000,
    showClose: true
  }

  constructor (props) {
    super(props)

    this.closeTimeout = null
    this.removeFromStateTimer = null
    this.initTimeout = null

    this.state = {
      open: false
    }

    this.handleOpen = this.handleOpen.bind(this)
    this.handleClose = this.handleClose.bind(this)
  }

  componentDidMount () {
    if (!this.state.open) {
      this.initTimeout = setTimeout(() => {
        if (!this.state.open) this.handleOpen()
      }, 1)
    }
  }

  componentWillUnmount () {
    delete this.closeTimeout
    delete this.removeFromStateTimer
    delete this.initTimeout // just incase we mount and unmount immediately?
  }

  handleOpen = () => {
    this.setState({
      open: true
    }, () => {
      if (this.props.timeout) {
        this.closeTimeout = setTimeout(() => {
          this.handleClose()
        }, this.props.timeout)
      }
    })
  }

  handleClose = () => {
    this.setState({
      open: false
    }, () => {
      this.removeFromStateTimer = setTimeout(() => {
        this.props.dispatch(remove(this.props.id))
      }, 250) // transition timeout
    })
  }

  render () {
    let classList = [
      classes.snackbar,
      {
        [classes.open]: this.state.open && classes.open,
        [classes.showClose]: this.props.showClose && classes.showClose,
        [classes[`snackbar--${this.props.notification_type}`]]: classes[`snackbar--${this.props.notification_type}`]
      }
    ]

    return <div className={cx(classList)}>
      <div className={classes.message}>{this.props.message || ''}</div>
      {!!this.props.showClose && <div className={classes.close} onClick={this.handleClose}><MdCancel /></div>}
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/components/Snackbar/Snackbar.js